import { gql } from '@lojinha/palantir'

export const MEAL_QUERY = gql`
  query GetMeal($slug: String!, $distributionCenterId: String) {
    mealBySlug(slug: $slug) {
      name
      id
      sku
      categories
      kind
      classification
      price
      priceFrom
      description
      imageUrl
      weight
      unit
      allergenics
      sellingStatus
      subtitle
      mainProduct
      isAvailable(distributionCenterId: $distributionCenterId)
      seo {
        url
      }
      itemTags(maxTags: 4) {
        totalCount
        nodes {
          colorPalette
          content
        }
      }
      products {
        id
        name
        ingredients
      }
      nutritionFacts {
        portionSize
        portionUnit
        facts {
          label
          value
          unit
          dailyValuePercentage
        }
      }
    }
  }
`
